import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, inject } from '@angular/core';
import {HydraService} from '../../../core/services/hydra.service';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {LocalStorage, LocalStorageService} from 'ngx-webstorage';
import {FiltersDossierComponent, FiltersDossierValues} from '../filters-dossier/filters-dossier.component';
import {environment} from '../../../../environments/environment';
import {FilterSearchComponent, FilterSearchValue} from '../filter-search/filter-search.component';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {
    RapportScientifiqueScheduling,
    RapportScientifiqueSchedulingStatut
} from '../../../interface/api/RapportScientifiqueScheduling';
import {DateService} from '../../../core/services/date.service';
import {FilterByAPIComponent, filterConfiguration} from '../../filter-by-api/filter-by-api.component';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {debounceTime} from 'rxjs/operators';
import {ModalSaisieDateComponent} from '../modal-saisie-date/modal-saisie-date.component';
import {MatDialog} from '@angular/material/dialog';
import {ToolsService} from '../../services/tools/tools.service';
import {ModalDashboardTaskComponent} from '../modal-dashboard-task/modal-dashboard-task.component';
import {DossierInterface} from '../../../class/api/Dossier';
import {ModalConfirmationComponent} from '../modal-confirmation/modal-confirmation.component';
import { DatePipe, UpperCasePipe } from '@angular/common';
import {MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {
    MatDatepickerToggle,
    MatDateRangeInput,
    MatDateRangePicker,
    MatEndDate,
    MatStartDate
} from '@angular/material/datepicker';
import {AutoSizeDirective} from '../../../directives/auto-size.directive';
import {
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable
} from '@angular/material/table';
import {RouterLink} from '@angular/router';
import {MatIconAnchor, MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatMenu, MatMenuItem, MatMenuTrigger} from '@angular/material/menu';
import {TranslateModule} from '@ngx-translate/core';
import {StatutDossier} from "../../../class/ex/ex-dossier";

interface rsScheduleView extends RapportScientifiqueScheduling {
    nbJoursRemise?: number;
}


@Component({
    selector: 'app-rapports-scientifiques',
    templateUrl: './rapports-scientifiques.component.html',
    styleUrls: ['./rapports-scientifiques.component.scss'],
    imports: [
    FiltersDossierComponent,
    FilterSearchComponent,
    FilterByAPIComponent,
    MatFormField,
    MatLabel,
    MatDateRangeInput,
    FormsModule,
    ReactiveFormsModule,
    MatStartDate,
    MatEndDate,
    MatDatepickerToggle,
    MatSuffix,
    MatDateRangePicker,
    AutoSizeDirective,
    MatTable,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    RouterLink,
    MatIconButton,
    MatIcon,
    MatIconAnchor,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatPaginator,
    UpperCasePipe,
    DatePipe,
    TranslateModule
]
})
export class RapportsScientifiquesComponent implements AfterViewInit {
    authService = inject(AuthentificationService);
    private hydraService = inject(HydraService);
    private changeDetector = inject(ChangeDetectorRef);
    private matDialog = inject(MatDialog);
    private toolsService = inject(ToolsService);
    private storage = inject(LocalStorageService);


    @ViewChild(MatSort, {static: false}) sort: MatSort;
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    filtersDossierValues?: FiltersDossierValues;
    search?: string;
    @LocalStorage('GLOBAL_item_par_page') pagesize;

    @Input() cacheKey: string = 'SUIVI_RS'
    @Input() title = 'RAPPORTS SCIENTIFIQUES';
    @Input() filtersAap = true;
    @Input() forcedFilters: { key: string; value: string }[] = [];
    @Input() allowExclusionAction = false;

    @Input() columns: string[] = [
        'candidat.nom',
        'aide.label',
        'rapportScientifiqueConfiguration.libelle',
        'dateDebutFinancement',
        'dateFinFinancement',
        'dureeReelle',
        'rapportScientifique',
        'statut',
        'dateOuverture',
        'dateRemise',
        'avancement',
        'actions',
    ];

    @Output() onDossierExclu = new EventEmitter<DossierInterface>();
    @Output() onDossierReintegre = new EventEmitter<DossierInterface>();

    @LocalStorage() public dateShort;

    pageSizeOptions = [10, 20, 30, 50, 100];
    total = 0;
    autoSize = 180;
    selectedSort = null;
    filterSearchValue: FilterSearchValue;

    filterStatut: filterConfiguration = {
        label: 'general.statut',
        api: null,
        displayProperty: 'label',
        propertyTranslatable: false,
        multipleSelect: true,
        data: [
            {label: 'A venir', value: 'a_venir'},
            {label: 'A saisir', value: 'a_saisir'},
            {label: 'En cours', value: 'en_cours'},
            {label: 'Validé', value: 'valide'},
            {label: 'En expertise', value: 'expertise'},
            {label: 'Traité', value: 'traite'},
        ],
    };

    filterStatutDossier: filterConfiguration = {
        label: 'Statut dossier',
        api: null,
        displayProperty: 'label',
        propertyTranslatable: false,
        multipleSelect: true,
        data: [
            {label: 'Accepté', value: StatutDossier.Accepte.toString()},
            {label: 'Désisté', value: StatutDossier.Desiste.toString()},
        ],
    };

    filterRetard: filterConfiguration = {
        label: 'Retard',
        api: null,
        displayProperty: 'label',
        propertyTranslatable: false,
        multipleSelect: true,
        data: [
            {label: 'Risque de retard', value: 'risque'},
            {label: 'Retard', value: 'retard'},
        ],
    };

    liste?: rsScheduleView[];
    loading = false;
    cacheInitEnd = false;

    nbJoursRelance = 15;

    statuts: string[];
    statutsDossier: string[];
    filtresRetard: string[];
    rangeDateRemise: UntypedFormGroup;

    filtersValueChange: EventEmitter<null> = new EventEmitter<null>();
    statutsEnum = RapportScientifiqueSchedulingStatut;
    StatutDossier = StatutDossier;

    constructor() {
        const rangeDateRemise = new UntypedFormGroup({
            start: new UntypedFormControl(),
            end: new UntypedFormControl(),
        });
        rangeDateRemise.valueChanges
            .pipe(
                debounceTime(250)
            )
            .subscribe(
                (event) => {
                    this.refreshFilters();
                }
            );
        this.rangeDateRemise = rangeDateRemise;


        // the filters initialization will trigger this :
        this.filtersValueChange.pipe(
            debounceTime(200)
        ).subscribe(
            () => this.getCollection()
        );
    }


    ngAfterViewInit(): void {
        this.filtersDossierValues = this.storage.retrieve(this.cacheKey + '_filters_dossier')
        this.search = this.storage.retrieve(this.cacheKey + '_seach');

        this.filterSearchValue = new FilterSearchValue(this.search ?? '');

        if (this.filtersDossierValues === undefined || this.filtersDossierValues == null) {
            this.filtersDossierValues = new FiltersDossierValues();
        } else {
            const {annees, commission, commissionSeance, aideSousTypes, aides} = this.filtersDossierValues;
            this.filtersDossierValues = new FiltersDossierValues(annees, commission, commissionSeance, aideSousTypes, aides);
        }

        if (!this.pagesize) {
            this.pagesize = 30;
        }
        this.paginator.pageSize = this.pagesize;

        this.filterStatut.cacheKey = this.cacheKey + '_filter-statut-rs';
        this.filterStatutDossier.cacheKey = this.cacheKey + '_filter-statut-dossier';
        this.filterRetard.cacheKey = this.cacheKey + '_filter-retard';

        this.cacheInitEnd = true;
        console.log(this.cacheInitEnd)
        this.filtersValueChange.emit();
        this.changeDetector.detectChanges();
    }

    getCollection() {
        this.loading = true;

        const url = this.construcUrlCollection();
        this.hydraService.getList(url).subscribe(
            (res) => {
                this.total = +res['hydra:totalItems'];
                this.liste = res.getMember().map(
                    (item) => ({
                        ...item,
                        nbJoursRemise: this.computeRetard(item)
                    })
                );
                this.loading = false;
                document.getElementsByClassName('container-mat-table-sticky')[0].scrollTo(0, 0);

            }
        );
    }

    private construcUrlCollection() {

        const wantPage = this.paginator.pageIndex + 1;

        let url = this.filtersDossierValues.applyFilters(
            new URL(
                environment.apiHost + '/api/rapport_scientifique_schedulings' + '?page=' + wantPage + '&itemsPerPage=' + this.paginator.pageSize
            )
        );

        if (this.filterSearchValue != null && this.filterSearchValue.applyFilters !== undefined) {
            url = this.filterSearchValue.applyFilters(url);
        }

        this.statuts?.forEach(
            (statut) => url.searchParams.append('statut[]', statut)
        );
        this.statutsDossier?.forEach(
            (statut) => url.searchParams.append('statutDossier[]', statut)
        );
        this.filtresRetard?.forEach(
            (statut) => url.searchParams.append('retard[]', statut)
        );

        const startDateRemise = this.rangeDateRemise.get('start')?.value;
        const endDateRemise = this.rangeDateRemise.get('end')?.value;

        if (startDateRemise) {
            url.searchParams.append('dateRemise[after]', DateService.getIsoDate(startDateRemise.toString()));
        }
        if (endDateRemise) {
            url.searchParams.append('dateRemise[before]', DateService.getIsoDate(endDateRemise.toString()));
        }

        this.forcedFilters.forEach(
            (filter) => {
                url.searchParams.append(filter.key, filter.value);
            }
        );

        if (this.selectedSort && this.selectedSort.active && this.selectedSort.direction) {
            url = HydraService.appendOrderToURL({
                sorts: [{
                    prop: this.selectedSort.active,
                    dir: this.selectedSort.direction
                }]
            }, url);
        } else {
            url = HydraService.appendOrderToURL({sorts: [{prop: 'id', dir: 'desc'}]}, url);
        }
        return url.href;
    }

    public onFiltersDossierChange(values: FiltersDossierValues): void {
        this.filtersDossierValues = values;
        this.storage.store(this.cacheKey + '_filters_dossier', values)
        this.refreshFilters();
    }

    onFilterSearchChange(value: FilterSearchValue) {
        this.filterSearchValue = value;
        this.search = value.search;
        this.storage.store(this.cacheKey + '_search', value.search)
        this.refreshFilters();
    }

    onFilterStatutDossierChange(event: null | { value: string }[]) {
        this.statutsDossier = event?.map(i => i.value) ?? [];
        this.refreshFilters();
    }

    onFilterStatutChange(event: null | { value: string }[]) {
        this.statuts = event?.map(i => i.value) ?? [];
        this.refreshFilters();
    }

    onFilterRetardChange(event: null | { value: string }[]) {
        this.filtresRetard = event?.map(i => i.value) ?? [];
        this.refreshFilters();
    }

    public changeSort(event: { active: string; direction: string }) {
        this.reinitPagerParams();
        if (event) {
            this.selectedSort = event;
            this.refreshFilters();
        }
        return false;
    }

    public onPaginatorPageChange() {
        this.pagesize = this.paginator.pageSize;
        this.filtersValueChange.emit();
    }

    editDates(rsScheduling: rsScheduleView) {
        rsScheduling['editing'] = true;

        this.matDialog.open(ModalSaisieDateComponent, {
            width: '690px',
            data: {
                title: 'Modification dates ouverture/remise',
                textContent: 'Les dates seront alors figées et ne seront plus calculées en fonction des dates de fin ou de début de projet. Pour rétablir le calcul automatique, laissez la ou les dates vides.',
                value: [
                    {
                        label: 'Date d\'ouverture',
                        identifier: 'dateOuverture',
                        value: rsScheduling.rapportScientifiqueConfigurationDossier?.dateOuverture,
                        required: false,
                        beforeIdentifier: 'dateRemise',
                    },
                    {
                        label: 'Date de remise',
                        identifier: 'dateRemise',
                        value: rsScheduling.rapportScientifiqueConfigurationDossier?.dateRemise,
                        required: false,
                        afterIdentifier: 'dateOuverture',
                    },
                ],
                formGroupValidator: (formGroup: UntypedFormGroup) => {
                    const dateRemise = formGroup.get('dateRemise');
                    if (!dateRemise.value) {
                        return null;
                    }

                    const dateOuverture = formGroup.get('dateOuverture');
                    if (!dateOuverture.value || dateOuverture.value === '') {
                        return {
                            customError: 'Si la date de remise est personnalisée, alors la date d\'ouverture doit l\'être également',
                        };
                    }

                    return null;
                }
            },
        })
            .afterClosed()
            .subscribe(res => {
                    rsScheduling['editing'] = false;

                    if (!res) {
                        return;
                    }

                    this.hydraService.save(
                        '/api/rapport_scientifique_configuration_dossiers',
                        {
                            '@id': HydraService.extractIRI(
                                rsScheduling.rapportScientifiqueConfigurationDossier
                            ),
                            rapportScientifiqueConfiguration: HydraService.extractIRI(
                                rsScheduling.rapportScientifiqueConfiguration
                            ),
                            dossier: HydraService.extractIRI(
                                rsScheduling.dossier
                            ),
                            dateOuverture: res.dateOuverture?.length ? res.dateOuverture : null,
                            dateRemise: res.dateRemise?.length ? res.dateRemise : null,
                        }
                    ).subscribe(
                        (resApi: any) => {
                            this.toolsService.notificationSuccess('Configuration enregistrée');
                            rsScheduling.rapportScientifiqueConfigurationDossier = resApi;
                            rsScheduling.dateOuverture = resApi.dateOuverture ?? rsScheduling.dateOuvertureCalcul;
                            rsScheduling.dateRemise = resApi.dateRemise ?? rsScheduling.dateRemiseCalcul;
                            rsScheduling.nbJoursRemise = this.computeRetard(rsScheduling);
                        }
                    );
                }
            );
    }


    private reinitPagerParams() {
        this.paginator.pageIndex = 0;
    }

    public refreshFilters() {
        this.reinitPagerParams();
        this.filtersValueChange.emit();
    }

    private computeRetard(item: RapportScientifiqueScheduling): number | null {
        if (item.rapportScientifique?.valide) {
            return null;
        }
        if (
            [
                RapportScientifiqueSchedulingStatut.expertise,
                RapportScientifiqueSchedulingStatut.traite,
            ].includes(item.statut)
        ) {
            return null;
        }

        return DateService.getDiffInDays(item.dateRemise, new Date());
    }

    openComments(item: RapportScientifiqueScheduling) {
        item['editing'] = true;
        this.matDialog.open(
            ModalDashboardTaskComponent,
            {
                width: '92vw',
                data: {
                    canCreateTasks: true,
                    wording: {
                        creationButtonLabel: 'Ajouter un suivi',
                    },
                    target: item.activityCommentsTarget,
                }
            }
        ).afterClosed().subscribe(
            (taskCreated) => {
                item['editing'] = false;

                if (taskCreated) {
                    item.hasOpenTask = true;
                }
            }
        );
    }

    exclureDossier(item: RapportScientifiqueScheduling) {
        item['editing'] = true;

        this.matDialog.open(
            ModalConfirmationComponent,
            {
                data: {
                    content:
                        'Exclure le dossier ' + item.dossier.numeroDossier + ' ?',
                    confirm: 'Oui',
                    cancel: 'Non',
                },
            }
        ).afterClosed().subscribe(
            (res) => {
                item['editing'] = false;

                if (res) {
                    this.hydraService.post(
                        '/api/rapport_scientifique_configurations/exclusion_dossier_requests',
                        {
                            rapportScientifiqueConfiguration: HydraService.extractIRI(item.rapportScientifiqueConfiguration),
                            dossier: HydraService.extractIRI(item.dossier),
                        }
                    ).subscribe(
                        () => {
                            this.toolsService.notificationSuccess('Dossier exclu');
                            this.onDossierExclu.emit(item.dossier);
                            item.exclu = true;
                        }
                    );
                }
            }
        );
    }

    reintegrerDossier(item: RapportScientifiqueScheduling) {
        item['editing'] = true;

        this.matDialog.open(
            ModalConfirmationComponent,
            {
                data: {
                    content:
                        'Réintégrer le dossier ' + item.dossier.numeroDossier + ' ?',
                    confirm: 'Oui',
                    cancel: 'Non',
                },
            }
        ).afterClosed().subscribe(
            (res) => {
                item['editing'] = false;

                if (res) {
                    this.hydraService.post(
                        '/api/rapport_scientifique_configurations/reintegration_dossier_requests',
                        {
                            rapportScientifiqueConfiguration: HydraService.extractIRI(item.rapportScientifiqueConfiguration),
                            dossier: HydraService.extractIRI(item.dossier),
                        }
                    ).subscribe(
                        () => {
                            this.toolsService.notificationSuccess('Dossier réintégré');
                            this.onDossierReintegre.emit(item.dossier);
                            item.exclu = false;
                        }
                    );
                }
            }
        );
    }

    marquerCommeTraite(item: rsScheduleView) {
        item['editing'] = true;

        this.matDialog.open(
            ModalConfirmationComponent,
            {
                data: {
                    content:
                        'Marquer le rapport comme traité ?',
                    confirm: 'Oui',
                    cancel: 'Non',
                },
            }
        ).afterClosed().subscribe(
            (res) => {
                item['editing'] = false;

                if (res) {
                    this.hydraService.put(
                        HydraService.extractIRI(item.rapportScientifique) + '/traite',
                        {}
                    ).subscribe(
                        () => {
                            this.toolsService.notificationSuccess('Rapport marqué comme traité');
                            item.statut = RapportScientifiqueSchedulingStatut.traite;
                            item.nbJoursRemise = null;
                        }
                    );
                }
            }
        );
    }


    passerEnExpertise(item: rsScheduleView) {
        item['editing'] = true;

        this.matDialog.open(
            ModalConfirmationComponent,
            {
                data: {
                    content:
                        'Passer le rapport en expertise ?',
                    confirm: 'Oui',
                    cancel: 'Non',
                },
            }
        ).afterClosed().subscribe(
            (res) => {
                item['editing'] = false;

                if (res) {
                    this.hydraService.put(
                        HydraService.extractIRI(item.rapportScientifique) + '/passerEnExpertise',
                        {}
                    ).subscribe(
                        () => {
                            this.toolsService.notificationSuccess('Rapport passé en expertise');
                            item.statut = RapportScientifiqueSchedulingStatut.expertise;
                            item.nbJoursRemise = null;
                        }
                    );
                }
            }
        );
    }

    rouvrir(item: rsScheduleView) {
        item['editing'] = true;

        this.matDialog.open(
            ModalConfirmationComponent,
            {
                data: {
                    content:
                        'Rouvrir le rapport ?',
                    confirm: 'Oui',
                    cancel: 'Non',
                },
            }
        ).afterClosed().subscribe(
            (res) => {
                item['editing'] = false;

                if (res) {
                    this.hydraService.put(
                        HydraService.extractIRI(item.rapportScientifique) + '/reouvertureSaisie',
                        {}
                    ).subscribe(
                        () => {
                            this.toolsService.notificationSuccess('Rapport rouvert');
                            item.statut = RapportScientifiqueSchedulingStatut.enCours;
                            item.nbJoursRemise = this.computeRetard(item);
                        }
                    );
                }
            }
        );
    }
}
